// Empire Dashboard V2 – Full Trade Feed + Twilio Trigger + Journal Export

import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import './index.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function App() {
  const [manualAlerts, setManualAlerts] = useState([]);
  const [aiStrategy, setAiStrategy] = useState('Basic');
  const [smsSent, setSmsSent] = useState(false);

  useEffect(() => {
    fetch('http://localhost:5001/api/alerts/manual')
      .then((res) => res.json())
      .then((data) => {
        setManualAlerts(data);
        if (data.length > 0) setSmsSent(true);
      })
      .catch((err) => console.error('Failed to fetch manual alerts:', err));
  }, []);

  const generateAISignal = () => {
    const signal =
      aiStrategy === 'Aggressive'
        ? 'BUY - High risk, high gain detected'
        : aiStrategy === 'Experimental'
        ? 'HOLD - Unstable trend, monitoring'
        : 'BUY - Low risk opportunity';
    fetch('http://localhost:5001/api/sms/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: `AI Signal (${aiStrategy}): ${signal}` }),
    });
    alert(`📡 AI Signal Generated (${aiStrategy}):\n${signal}`);
  };

  const exportJournal = () => {
    const csv = manualAlerts.map(a => `${a.asset},${a.reason},${a.time},${a.status}`).join('\n');
    const blob = new Blob([`Asset,Reason,Time,Status\n${csv}`], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'journal_export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 bg-gray-900 min-h-screen text-white">
      <h1 className="text-2xl font-bold mb-4">🚨 Empire Signal & Alert Center</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6 text-sm">
        <div className="bg-gray-800 p-4 rounded">📈 52-Week Highs<br />Live monitoring</div>
        <div className="bg-gray-800 p-4 rounded">📣 IPO Surges<br />Auto-scan enabled</div>
        <div className="bg-gray-800 p-4 rounded">🟡 Manual Attention<br />Flag queue active</div>
        {smsSent && (
          <div className="bg-green-800 p-4 rounded col-span-2">📲 SMS Alert Sent<br />Notification active</div>
        )}
      </div>

      <div className="overflow-x-auto mb-6">
        <table className="min-w-full text-left text-sm border border-gray-700">
          <thead className="bg-gray-700 text-gray-300">
            <tr>
              <th className="p-2">Asset</th>
              <th className="p-2">Reason</th>
              <th className="p-2">Time</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {manualAlerts.map((alert, idx) => (
              <tr key={idx} className="border-t border-gray-700 hover:bg-gray-800">
                <td className="p-2">{alert.asset}</td>
                <td className="p-2">{alert.reason}</td>
                <td className="p-2">{alert.time}</td>
                <td className="p-2">{alert.status} <span className="text-yellow-400 ml-2">(Manual)</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6">
        <label className="block text-sm font-medium mb-2">🎯 AI Strategy Mode</label>
        <select
          value={aiStrategy}
          onChange={(e) => setAiStrategy(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded"
        >
          <option value="Basic">Basic</option>
          <option value="Aggressive">Aggressive</option>
          <option value="Experimental">Experimental</option>
        </select>

        <div className="mt-4 flex gap-4">
          <button
            className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
            onClick={generateAISignal}
          >
            🔮 Generate AI Signal
          </button>
          <button
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded"
            onClick={exportJournal}
          >
            🧾 Export Journal CSV
          </button>
        </div>
      </div>
    </div>
  );
}
